import { render, staticRenderFns } from "./SubjectFollowup.vue?vue&type=template&id=f3440216&"
import script from "./SubjectFollowup.vue?vue&type=script&lang=js&"
export * from "./SubjectFollowup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports